import { ColophonProvider } from '@!/providers'
import { Colophon } from '../containers/Colophon'

const ColophonApp = (props) => {
  if (!props.content) return null

  return (
    <ColophonProvider>
      <Colophon content={props.content} />
    </ColophonProvider>
  )
}

export default ColophonApp
